module.exports = __webpack_public_path__ + "static/media/goIcon.b16e274a.svg";